import { time } from "../frameloop/sync-time.js";
import { frame, cancelFrame } from "../frameloop/frame.js";
function delay(callback, timeout) {
  const start = time.now();
  const checkElapsed = ({ timestamp }) => {
    const elapsed = timestamp - start;
    if (elapsed >= timeout) {
      cancelFrame(checkElapsed);
      callback(elapsed - timeout);
    }
  };
  frame.read(checkElapsed, true);
  return () => cancelFrame(checkElapsed);
}
export {
  delay
};
//# sourceMappingURL=delay.js.map
